<div class="bookings-container">
    <div class="header-and-form-container">
      <div class="header-container"
           mat-dialog-title>
        <div class="header-title">
          Relatório de Reservas - {{show?.title}}
        </div>
        <div class="header-close"
             mat-dialog-close>
          <span class="material-icons icon-close"> close </span>
        </div>
      </div>
      <mat-dialog-content>
        <div class="filters">
          <app-search-bar
            #textSearch
            actionText="Pesquisar"
            placeholder="Pesquise por nomes"
            (search)="filterText($event)"
          ></app-search-bar>
          <app-booking-status-select
            [active]="bookingStatusFilter"
            (activeChange)="handleChangeStatus($event)"
          ></app-booking-status-select>
          <div class="reset-filter">
            <button
              class="btn-reset"
              (click)="resetFilters()"
              [disabled]="disableResetFilters"
            >
              Limpar filtros
            </button>
          </div>
        </div>
        <div class="table-container">
          <table mat-table [dataSource]="bookingsFiltered" class="mat-elevation-z8">

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
          
            <!-- Position Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Nome </th>
              <td mat-cell *matCellDef="let element"> {{
                getName(element)
              }} </td>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let element"> {{ element.status === 'CANCELED' ? 'Cancelada' : 'Confirmada'
                }} </td>
            </ng-container>
          
            <!-- Weight Column -->
            <ng-container matColumnDef="seats">
              <th mat-header-cell *matHeaderCellDef> Cadeiras </th>
              <td mat-cell *matCellDef="let element"> {{concatSeatsString(element.seats)}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </mat-dialog-content>
    </div>
  </div>
  